var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',_vm._g({class:_vm.classes,attrs:{"name":_vm.nameIcon}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }